const template = require('./index.html')
const makeItLabel = require('@isoftdata/label')
const { v4: uuid } = require('@lukeed/uuid')

const defaultOptions = {
	twoway: false,
	lazy: true,
	isolated: true,
}

module.exports = function makeCheckboxComponent({
	twoway = false,
	lazy = true,
	isolated = true,
} = defaultOptions) {
	return Ractive.extend({
		template,
		twoway,
		lazy,
		isolated,
		components: {
			itLabel: makeItLabel(),
		},
		attributes: {
			required: [],
			optional: [
				'id',
				'label',
				'labelId',
				'labelClass',
				'showLabel',
				'class',
				'textareaStyle',
				'isLoading',
				'wasSaved',
				'hasError',
				'selectOnFocus',
				'savedInputIdList',
			],
		},
		data() {
			return {
				id: `id${uuid()}`,
				label: null,
				showLabel: true,
				styleClass: '',
				isLoading: false,
				wasSaved: false,
				hasError: false,
				selectOnFocus: false,
				savedInputIdList: [],
			}
		},
		oninit() {
			//const ractive = this
		},
		clear(value = '') {
			const el = this.find(`#${this.get('id')}`)

			if (el) {
				el.value = value
			}
		},
		onteardown() {
			try {
				//this could throw an error if the element is not rendered to the DOM yet.
				this.clear()
			} catch (err) {
				//swallow
			}
		},
	})
}
